import { CommitmentSourcesService_commitmentSourcesServiceGetEntity } from '@festina/life-general-types/life/hooks/CommitmentSourcesService_commitmentSourcesServiceGetEntity'

export const useLazyExportCommitment =
  CommitmentSourcesService_commitmentSourcesServiceGetEntity.useLazyQuery
